import React from "react";
import {
  Modal,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function CategoryFormModal({
  open,
  handleClose,
  categoryData,
  handleInputChange,
  handleFileChange,
  handleSubmit,
  isEditing,
}) {
  return (
    <Modal open={open} onClose={handleClose}>
      <MDBox
        p={3}
        bgcolor="white"
        borderRadius="lg"
        style={{
          width: 900,
          margin: "50px auto",
          outline: "none",
          backgroundColor: "white",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <MDTypography variant="h6" mb={2}>
          {isEditing ? "Edit Category" : "Add Category"}
        </MDTypography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                label="Color"
                name="color"
                type="color"
                value={categoryData.color}
                onChange={handleInputChange}
                margin="normal"
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Title (EN)"
                name="name_en"
                value={categoryData.name_en}
                onChange={handleInputChange}
                margin="normal"
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Title (FR)"
                name="name_fr"
                value={categoryData.name_fr}
                onChange={handleInputChange}
                margin="normal"
                required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Description (EN)"
                name="description_en"
                value={categoryData.description_en}
                onChange={handleInputChange}
                margin="normal"
                multiline
                rows={3}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Description (FR)"
                name="description_fr"
                value={categoryData.description_fr}
                onChange={handleInputChange}
                margin="normal"
                multiline
                rows={3}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type="file"
                  id="file-input"
                  onChange={(e) => handleFileChange(e, 'image')}
                  style={{ display: 'none' }}
                />
                <label htmlFor="file-input">
                  <Button variant="outlined" component="span" style={{ width: '100%', color: 'gray' }}>
                    Upload Image
                  </Button>
                </label>
                {categoryData.image_preview && (
                  <img
                    src={categoryData.image_preview}
                    alt="Preview"
                    style={{ width: '100px', height: 'auto', marginLeft: '10px' }}
                  />
                )}
              </div>
            </Grid>
          </Grid>

          <MDBox mt={3} display="flex" justifyContent="flex-end">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{
                whiteSpace: "nowrap",
                color: "white",
              }}
            >
              {isEditing ? "Update" : "Add"}
            </Button>
          </MDBox>
        </form>
      </MDBox>
    </Modal>
  );
}

export default CategoryFormModal;